'use strict';

const {__} = wp.i18n;

/**
 * Init All Custom Fields Logic
 */
class TWER_CUSTOM_FIELDS {
  elementCount(arr, element){
    return arr.filter((currentElement) => currentElement == element).length;
  }
  /**
   * Uploads constructor
   *
   * @param props
   */
  constructor(props) {
    // Init JQuery
    this.$ = $ = props;

    const scope = this;

    $('.js-ui-slider-wrap').each((index, element) => {
      const $sortableList = $(element);
      $sortableList.sortable({
        cursor: 'move',
        placeholder: 'ui-sortable-placeholder twer-tr-toggle js-ui-slider-item',
        forcePlaceholderSize: true,
        forceHelperSize: true,
        scroll: true,
        revert: false,
        tolerance: 'pointer',
        handle: '.js-twer-ui-sort-tr',
        items: '> .js-ui-slider-item',
        create : function() {
          const $input = $sortableList.find('input.js-twer-custom-fields-list');
          let ids = [];
          $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
            ids.push($(div).data('id'));
          });
          //console.log(ids);
          $input.val(ids.join(','));
        },
        update: function(event, ui) {
         const $input = $sortableList.find('input.js-twer-custom-fields-list');
          let ids = [];
          $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
            ids.push($(div).data('id'));
          });
          //console.log(ids);
          $input.val(ids.join(','));
        }
      }).disableSelection();
    });

    $('select, input:checkbox').each(function(){

      const readOnly = $(this).attr('readonly');

      if(readOnly === 'readonly') {
        $(this).closest('.col-simple, .col-fixed').css({pointerEvents: "none"});
        $(this).closest('.col-simple, .col-fixed').addClass('penoneSelect');
      }

    });

    $(document).on('click', '.js-twer-ui-del-tr', function(e) {
      e.preventDefault();

      const $removeButton = $(this);
      const $sortableList = $removeButton.closest('.js-ui-slider-wrap');
      const $input = $sortableList.find('input.js-twer-custom-fields-list');
      const $select = $sortableList.find('.js-custom-fields-list');
      const ids = [];
      const id = parseInt($removeButton.closest('.js-ui-slider-item').data('id'));
      const label = $removeButton.closest('.js-ui-slider-item').find('th label').text();

      if (0 === $select.find('option[value=' + id + ']').length && !isNaN(id)) {
        $select.append(`<option value="${id}">${label}</option>`);
      }

      $removeButton.closest('.js-ui-slider-item').remove();
      $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
        ids.push($(div).data('id'));
      });
      $input.val(ids.join(','));


      const popupIds = $('#treweler-custom-fields-list').val().trim() !== '' ? $('#treweler-custom-fields-list').val().split(',').map(id => parseInt(id)) : [];
      const locatorPreviewIds = $('#treweler-custom-fields-list-locator-preview').val().trim() !== '' ? $('#treweler-custom-fields-list-locator-preview').val().split(',').map(id => parseInt(id)) : [];
      const locatorIds = $('#treweler-custom-fields-list-locator').val().trim() !== '' ? $('#treweler-custom-fields-list-locator').val().split(',').map(id => parseInt(id)) : [] ;

      const allCustomFieldsIds = [...popupIds, ...locatorPreviewIds, ...locatorIds];


      setTimeout(function(){
        if($removeButton.closest('.tab-pane').attr('id') !== 'twer-nav-custom-fields-wo-template' && scope.elementCount(allCustomFieldsIds, id) === 0) {
          const $uniqueInput = $('#treweler-custom-fields-list-unique');
          const $uniqueInputWrapper = $uniqueInput.closest('.js-ui-slider-wrap');
          const $uniqueRow = $uniqueInputWrapper.find('.js-ui-slider-item[data-id="'+id+'"]');
          $uniqueRow.find('.js-twer-ui-del-tr').trigger('click');
        }
      }, 500);

      setTimeout(() => {
        scope.toggleNotEditableFieldsNotice();
      }, 600);

    });


    $(document).on('click', '.js-add-custom-field', function(e){
      e.preventDefault();

      const $addButton = $(this);
      const $sortableWrap = $addButton.closest('.js-ui-slider-wrap');
      const $select = $sortableWrap.find('.js-custom-fields-list');
      const selectedId = $select.val();
      if('none' !== selectedId) {

        const $row = $sortableWrap.find('.js-hidden-item[data-id="' + selectedId + '"]').clone();
        const ids = [];

        $row.find('select.js-field-multiselect').select2({
          placeholder: 'No values selected',
          width: '100%',
          minimumResultsForSearch: -1,
        });

        $row.toggleClass('d-none js-ui-slider-item');
        $row.removeClass('js-hidden-item');

        $row.find('textarea:not(.select2-search__field), input:not(:checkbox):not(.js-twer-lock-status)').each(function(){
          const $input = $(this);
          $input.prop('disabled',false);
          $input.prop('readonly',true);
          $input.val($input.data('default'));
          $input.attr('value',$input.data('default'));
        });

        $row.find('input.js-twer-lock-status').each(function(){
          const $input = $(this);
          $input.prop('disabled',false);
          $input.prop('readonly',false);
          $input.val('close');
          $input.attr('value','close');
        });

        $row.find('.js-twer-lock').removeClass('twer-lock--open');


        $row.find('input:checkbox').each(function(){
          const $input = $(this);
          $input.prop('disabled',false);
          $input.prop('readonly',true);
          $input.prop( "checked", $input.data('default') );

          $input.closest('.col-fixed').css({pointerEvents: "none"});
        });

        $row.find('select').each(function(){
          const $input = $(this);
          $input.prop('disabled',false);
          $input.prop('readonly',true);

          let defaultValue = $input.data('default');

          if(defaultValue === '') {
            defaultValue = null;
          } else {
            defaultValue = typeof defaultValue === 'string' ? JSON.parse(defaultValue) : defaultValue;
          }
          $input.val(defaultValue).trigger('change');


          $input.closest('.col-simple').css({pointerEvents: "none"});
          $input.closest('.col-simple').addClass('penoneSelect');
        });


        $row.insertBefore($sortableWrap.find('.js-hidden-item:first'));
        $select.find('option:selected').remove();
        const $sortableList = $(this).closest('.js-ui-slider-wrap');
        const $input = $sortableList.find('input.js-twer-custom-fields-list');
        $sortableList.sortable('refresh');
        $sortableList.sortable('refreshPositions');
        $sortableList.children('.js-ui-slider-item').each(function(divIndex, div) {
          ids.push($(div).data('id'));
        });
        $input.val(ids.join(','));


        setTimeout(function(){
          if($addButton.closest('.tab-pane').attr('id') !== 'twer-nav-custom-fields-wo-template') {
            const $uniqueInput = $('#treweler-custom-fields-list-unique');
            const $uniqueInputWrapper = $uniqueInput.closest('.js-ui-slider-wrap');

            console.log(selectedId);

            $uniqueInputWrapper.find('.js-custom-fields-list').val(selectedId);
            $uniqueInputWrapper.find('.js-add-custom-field').trigger('click');
          }
        }, 500);

      }


      setTimeout(() => {
        scope.toggleNotEditableFieldsNotice();
      }, 700);
    });


    $(document).on('click','.js-twer-lock', function(e) {
      e.preventDefault();

      const $lock = $(this);
      const index = $lock.index();
      const lockStatus = $lock.hasClass('twer-lock--open') ? 'open' : 'close';
      let $field = $lock.closest('.twer-wrap-fields').find('.twer-group-elements .row');

      if($field.length > 0) {
        $field = $field.children().eq(index);
      } else {
        $field = $lock.closest('.twer-wrap-fields').find('.twer-form-group');
      }

      if('open' === lockStatus) {
        const $input = $field.find('textarea:not(.select2-search__field), input:not(.js-twer-lock-status):not(:checkbox)');
        $input.prop('readonly', true);
        $input.data('current', $input.val());
        $input.val($input.data('default'));
        $input.attr('value', $input.data('default'));
        $lock.removeClass('twer-lock--open');

        $field.find('.js-twer-lock-status').val('close');
        $field.find('.js-twer-lock-status').attr('value', 'close');


        const $checkbox = $field.find('input:checkbox');
        $checkbox.prop('disabled',false);
        $checkbox.prop('readonly',true);
        $checkbox.data('current', $checkbox.is(':checked'));
        $checkbox.prop( "checked", $input.data('default') );
        $checkbox.closest('.col-fixed').css({pointerEvents: "none"});


        const $select = $field.find('select');
        $select.prop('disabled',false);
        $select.prop('readonly',true);
        $select.data('current', JSON.stringify( $select.val() ));
        let defaultValue = $select.data('default');
        if(defaultValue === '') {
          defaultValue = null;
        } else {
          defaultValue = typeof defaultValue === 'string' ? JSON.parse(defaultValue) : defaultValue;
        }
        $select.val(defaultValue).trigger('change');
        $select.closest('.col-simple').css({pointerEvents: "none"});
        $select.closest('.col-simple').addClass('penoneSelect');
      }

      if('close' === lockStatus) {
        const $input = $field.find('textarea:not(.select2-search__field), input:not(.js-twer-lock-status):not(:checkbox)');
        $input.prop('readonly', false);
        $input.val($input.data('current'));
        $input.attr('value', $input.data('current'));
        $lock.addClass('twer-lock--open');

        $field.find('.js-twer-lock-status').val('open');
        $field.find('.js-twer-lock-status').attr('value', 'open');


        const $checkbox = $field.find('input:checkbox');
        $checkbox.prop('disabled',false);
        $checkbox.prop('readonly',false);
        $checkbox.prop( "checked", $checkbox.data('current') );
        $checkbox.closest('.col-fixed').css({pointerEvents: "auto"});


        const $select = $field.find('select');
        $select.prop('disabled',false);
        $select.prop('readonly',false);

        let currentValue = $select.data('current');
        if(currentValue === '') {
          currentValue = null;
        } else {
          currentValue = typeof currentValue === 'string' ? JSON.parse(currentValue) : currentValue;
        }
        $select.val(currentValue).trigger('change');
        $select.closest('.col-simple').css({pointerEvents: "auto"});
        $select.closest('.col-simple').removeClass('penoneSelect');
      }

    })

  }

  toggleNotEditableFieldsNotice() {
    const $notEditableCustomFieldsNotice = $('#js-twer-not-fields-message');
    if($notEditableCustomFieldsNotice.length > 0) {
      const allTrLength = $notEditableCustomFieldsNotice.closest('.tab-pane').find('tr').length;
      const allTrHiddenLength = $notEditableCustomFieldsNotice.closest('.tab-pane').find('tr.d-none').length;

      const allTrHiddenHardLength = $notEditableCustomFieldsNotice.closest('.tab-pane').find('tr.d-none-hard:not(.d-none)').length;

      const allTrHide = allTrHiddenLength + allTrHiddenHardLength;

      if (allTrLength === allTrHide) {
        $notEditableCustomFieldsNotice.removeClass('d-none');
      } else {
        $notEditableCustomFieldsNotice.addClass('d-none');
      }
    }
  }

}

export default TWER_CUSTOM_FIELDS;
